import React from 'react';
import { Page } from 'components';
import 'styles/static_pages.scss';
import classNames from 'lib/classNames';

const PrivacyPolicy = () => (
	<Page
		background="none"
		padding={0}
		header={{
			title: 'Privacy Policy',
		}}
	>
		<div className={classNames('text-gray-700 static_page')}>
			<h4>Privacy Policy</h4>
			<p>
				(Basically we are serious about your privacy!)
				<br /> <br /> MonsterApps provides applications ("the Service") to merchants who use Shopify to build
				and maintain their online store. This Privacy Policy provide detailed information on how data is
				collected, used, and shared when you install or use our apps with your Shopify store.
			</p>

			<h4>Personal Data We Process</h4>
			<p>
				When you install our apps, we are automatically able to access certain types of information from your
				Shopify account. See more detailed information in Shopify's help docs.
			</p>
			<p>
				In addition, we store the following personal information: Emails, names and location of our customers
				that are necessary for localized email notifications, reports, support, product updates and reminders.
			</p>

			<h4>How We Use Personal Data</h4>
			<p>
				We use the personal information we collect from you in order to provide the Service and to operate our
				apps. Additionally, we use the personal information to: communicate with you, optimize or improve the
				Service, provide you with information about our products, and handling software bugs or support
				requests.
			</p>
			<p>
				We also use your Personal Information to provide you with targeted advertisements or marketing
				communications we believe may be of interest to you. For more information about how targeted advertising
				works, you can visit the Network Advertising Initiative&rsquo;s (&ldquo;NAI&rdquo;) educational page at
				http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work.
			</p>
			<p>
				You can opt out of some of these services by visiting the Digital Advertising Alliance&rsquo;s opt-out
				portal at: http://optout.aboutads.info/.
			</p>

			<h4>Sharing Your Information</h4>
			<p>
				We do not share your Personal Information with any third parties. We may share your Personal Information
				to comply with applicable laws and regulations, to respond to a subpoena, search warrant or other lawful
				request for information we receive, or to otherwise protect our rights.
			</p>

			<h4>Your Rights</h4>
			<p>
				If you are in the EU, you have the right to access, update or delete your Information and obtain a copy
				of your information we store on our systems and have us update, correct or delete it. You are also
				entitled to obtain your Information (excluding data obtained from other sources) in a structured,
				commonly used and machine-readable format, and have the right to transmit those data to another data
				controller. If you wish to exercise any of these rights, contact us directly at
				support@monsterapps.shop. You have a right to submit a complaint to the relevant supervisory data
				protection authority.
			</p>
			<p>
				If you are in the EU, you can lodge a complaint to the supervisory authority under the General data
				Protection Regulations ("GDPR"), in particular in the Member State of your residence, place of work or
				where the alleged infringement of the GDPR occurred.
			</p>

			<h4>Age Of Consent</h4>
			<p>
				By using our apps, you indicate that you are at least 13 years of age or at least the age of majority in
				your state or province of residence to use the App.
			</p>

			<h4>Changes To The Privacy Policy</h4>
			<p>
				We may update this privacy policy at any time in order to reflect, for example, changes to our practices
				or for other operational, legal or regulatory reasons. If we make changes to this policy, we will notify
				you by email of updates, so that you are aware of information we collect, how we use it, and under what
				circumstances, if any.
			</p>

			<h4>Contact Information</h4>
			<p>
				If you would like to access, correct, amend or delete any personal information, or require any
				additional information about our privacy policy please contact us at{' '}
				<a
					href="mailto:support@monsterapps.shop"
					target="_blank"
					className={classNames('text-blue-500 font-bold')}
				>
					support@monsterapps.shop
				</a>
			</p>
		</div>
	</Page>
);

export default PrivacyPolicy;
